import React from "react";

export const BackButton = () => {
    return (
        <button className="section-heading__back-button" type="button" aria-label="назад">
            &#10229;
        </button>
    );
};
